import React, { useState, useEffect } from "react";
import "../../css/classes/dashboardHeaderStats.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PieChartIcon from "@mui/icons-material/PieChart";
import SavingsIcon from "@mui/icons-material/Savings";
import CreditCardIcon from "@mui/icons-material/CreditCard";

const DashboardHeaderStats = ({ apiData }) => {
  console.log("apiData", apiData)
  const [availableBalance, setavailableBalance] = useState(apiData?.api1?.budgetLeft ?? 0);
  const [moneyIn, setmoneyIn] = useState(apiData?.api1?.totalBudget ?? 0);
  const [moneyOut, setmoneyOut] = useState(apiData?.api1?.totalExpense ?? 0);
  const [previousBalance, setpreviousBalance] = useState(apiData?.api1?.prevBalance ?? 0);
  const [distributionData, setdistributionData] = useState([
    {
      label: "Money In",
      value: "60,600.00",
      icon: <TrendingUpIcon style={{ color: "#4ECDC4", fontSize: "20px" }} />,
    },
    {
      label: "Previous Balance",
      value: "500.00",
      icon: (
        <AccountBalanceWalletIcon
          style={{ color: "#8B5FBF", fontSize: "20px" }}
        />
      ),
    },
    { label: "Total", value: "61,100.00", highlight: true },
  ]);
  const [pieData, setpieData] = useState([
  ]);

  useEffect(() => {
    setavailableBalance(apiData?.api1?.budgetLeft ?? 0)
    setmoneyIn(apiData?.api1?.totalBudget ?? 0)
    setmoneyOut(apiData?.api1?.totalExpense ?? 0)
    setpreviousBalance(apiData?.api1?.prevBalance ?? 0)
    setdistributionData([
      {
        label: "Money In",
        value: apiData?.api1?.totalBudget ?? 0,
        icon: <TrendingUpIcon style={{ color: "#4ECDC4", fontSize: "20px" }} />,
      },
      {
        label: "Previous Balance",
        value: apiData?.api1?.prevBalance ?? 0,
        icon: (
          <AccountBalanceWalletIcon
            style={{ color: "#8B5FBF", fontSize: "20px" }}
          />
        ),
      },
      { label: "Total", value: apiData?.api1?.total ?? 0, highlight: true },
    ])
    setpieData([
      { name: "Expenses", value: apiData?.api1?.totalExpense ?? 0, color: "#FF4B6E" },
      // { name: "Bills", value: 503.0, color: "#4ECDC4" },
      // { name: "Savings", value: 20680.0, color: "#8B5FBF" },
      // { name: "Debts", value: 4300.0, color: "#4A90E2" },
      { name: "Amount Left", value: apiData?.api1?.budgetLeft ?? 0, color: "#4A90E2" },
    ])
  }, [apiData?.api1])

  return (
    <div className="dashboard-container">
      <div className="dashboard-left">
        <div className="balance-card">
          <div className="balance-header">
            <div className="balance-icon">
              <AccountBalanceWalletIcon
                style={{ color: "white", fontSize: "24px" }}
              />
            </div>
            <div className="balance-content">
              <p className="balance-label">Available Balance</p>
              <h1 className="balance-amount">
                ₹ {availableBalance.toFixed(2)}
              </h1>
              <p className="balance-subtitle">
                of actual income left to be allocated
              </p>
            </div>
          </div>
        </div>

        <div className="money-cards">
          <div className="money-card money-in-card">
            <div className="d-flex align-items-center">
              <div className="money-card-icon" style={{ marginRight: "1rem" }}>
                <TrendingUpIcon style={{ color: "white", fontSize: "20px" }} />
              </div>
              <span className="money-card-title">Money In</span>
            </div>

            <p className="money-card-amount">₹ {moneyIn}</p>
            <div className="money-card-footer">
              <span className="money-card-label">Previous Balance</span>
              <span className="money-card-value">
                ₹ {previousBalance.toFixed(2)}
              </span>
            </div>
          </div>

          <div className="money-card money-out-card">
            <div className="d-flex align-items-center">
              <div
                className="money-card-icon"
                style={{ marginRight: "1rem", background: "#ee6b96" }}
              >
                <ShoppingCartIcon
                  style={{ color: "white", fontSize: "20px" }}
                />
              </div>
              <span className="money-card-title">Money Out</span>
            </div>
            <p className="money-card-amount">₹ {moneyOut}</p>
            <p className="money-card-description">
              (Expenses + Bills + Debts + Savings)
            </p>
          </div>
        </div>

        <div className="spending-rate-card">
          <div className="rate-header">
            <PieChartIcon style={{ color: "#8B5FBF", fontSize: "20px" }} />
            <span>Spending & Saving Rate base on % allocated to Savings</span>
          </div>
          <div className="rate-content">
            <div className="rate-item spending">
              <p className="rate-label">You are spending</p>
              <h2 className="rate-percentage">{apiData?.api1?.spendingPercentage ?? 0}%</h2>
              <p className="rate-sublabel">of your income</p>
            </div>
            <div className="rate-divider"></div>
            <div className="rate-item saving">
              <p className="rate-label">You are saving</p>
              <h2 className="rate-percentage">{apiData?.api1?.savingPercentage ?? 0}%</h2>
              <p className="rate-sublabel">of your income</p>
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard-right">
        <div
          style={{
            background: "white",
            borderRadius: "24px",
            padding: "2rem",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
            border: "1px solid rgba(226, 232, 240, 0.8)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Background pattern */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "radial-gradient(circle at 70% 30%, rgba(139, 95, 191, 0.02) 0%, transparent 50%), radial-gradient(circle at 30% 70%, rgba(74, 144, 226, 0.02) 0%, transparent 50%)",
              pointerEvents: "none",
            }}
          />

          <div style={{ position: "relative", zIndex: 1 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "2rem",
              }}
            >
              <div>
                <h2
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    color: "#1e293b",
                    margin: "0 0 0.25rem 0",
                    letterSpacing: "-0.025em",
                  }}
                >
                  Money Distribution
                </h2>
                <p
                  style={{
                    fontSize: "0.875rem",
                    color: "#64748b",
                    margin: 0,
                    fontWeight: "500",
                  }}
                >
                  (Annual)
                </p>
              </div>

              <div
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "12px",
                  padding: "0.5rem",
                  color: "white",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                </svg>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gap: "1rem",
                marginBottom: "2rem",
              }}
            >
              {distributionData.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "1rem 1.5rem",
                    background: item.highlight
                      ? "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)"
                      : "rgba(248, 250, 252, 0.5)",
                    borderRadius: "16px",
                    border: item.highlight
                      ? "2px solid rgba(59, 130, 246, 0.3)"
                      : "1px solid rgba(226, 232, 240, 0.6)",
                    ...(item.highlight && {
                      transform: "scale(1.02)",
                      boxShadow: "0 4px 20px rgba(59, 130, 246, 0.1)",
                    }),
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                    }}
                  >
                    <span style={{ fontSize: "1.25rem" }}>{item.icon}</span>
                    <span
                      style={{
                        fontSize: item.highlight ? "1.125rem" : "1rem",
                        fontWeight: item.highlight ? "700" : "600",
                        color: item.highlight ? "#1e40af" : "#374151",
                      }}
                    >
                      {item.label}
                    </span>
                  </div>
                  <span
                    style={{
                      fontSize: item.highlight ? "1.25rem" : "1.125rem",
                      fontWeight: "700",
                      color: item.highlight ? "#1e40af" : "#1e293b",
                      fontFamily:
                        'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
                    }}
                  >
                    ₹{item.value}
                  </span>
                </div>
              ))}
            </div>

            {/* Main Chart and Detailed Breakdown */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              {/* Chart and Summary Side by Side */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "2rem",
                }}
              >
                {/* Pie Chart */}
                <div
                  style={{
                    flex: "0 0 260px",
                    height: "260px",
                    position: "relative",
                  }}
                >
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        data={pieData}
                        cx="50%"
                        cy="50%"
                        innerRadius={65}
                        outerRadius={110}
                        dataKey="value"
                        startAngle={90}
                        endAngle={450}
                      >
                        {pieData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>

                  {/* Center text */}
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      background: "rgba(255, 255, 255, 0.95)",
                      borderRadius: "50%",
                      width: "90px",
                      height: "90px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      backdropFilter: "blur(10px)",
                      border: "3px solid rgba(59, 130, 246, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "1.125rem",
                        fontWeight: "800",
                        color: "#1e293b",
                        fontFamily:
                          'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
                      }}
                    >
                      ₹{apiData?.api1?.totalBudget ?? 0}
                    </div>
                    <div
                      style={{
                        fontSize: "0.6rem",
                        color: "#64748b",
                        fontWeight: "600",
                        marginTop: "0.25rem",
                        letterSpacing: "0.5px",
                      }}
                    >
                      TOTAL
                    </div>
                  </div>
                </div>

                {/* Quick Summary Cards */}
                <div
                  style={{
                    flex: 1,
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "1rem",
                  }}
                >
                  {/* Expenses */}
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #FF4B6E05 0%, #FF4B6E15 100%)",
                      padding: "1.5rem",
                      borderRadius: "16px",
                      border: "2px solid #FF4B6E20",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "800",
                        color: "#FF4B6E",
                        fontFamily:
                          'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
                        marginBottom: "0.5rem",
                      }}
                    >
                      ₹{apiData?.api1?.totalExpense ?? 0}
                    </div>
                    <div
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "600",
                        color: "#374151",
                        marginBottom: "0.5rem",
                      }}
                    >
                      Expenses
                    </div>
                    {/* <div
                      style={{
                        background: "#FF4B6E",
                        color: "white",
                        padding: "0.25rem 0.75rem",
                        borderRadius: "12px",
                        fontSize: "0.75rem",
                        fontWeight: "700",
                        display: "inline-block",
                      }}
                    >
                      42%
                    </div> */}
                  </div>

                  {/* Savings */}
                  {/* <div
                    style={{
                      background:
                        "linear-gradient(135deg, #8B5FBF05 0%, #8B5FBF15 100%)",
                      padding: "1.5rem",
                      borderRadius: "16px",
                      border: "2px solid #8B5FBF20",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "800",
                        color: "#8B5FBF",
                        fontFamily:
                          'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
                        marginBottom: "0.5rem",
                      }}
                    >
                      ₹20,680
                    </div>
                    <div
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "600",
                        color: "#374151",
                        marginBottom: "0.5rem",
                      }}
                    >
                      Savings
                    </div>
                    <div
                      style={{
                        background: "#8B5FBF",
                        color: "white",
                        padding: "0.25rem 0.75rem",
                        borderRadius: "12px",
                        fontSize: "0.75rem",
                        fontWeight: "700",
                        display: "inline-block",
                      }}
                    >
                      34%
                    </div>
                  </div> */}

                  {/* Debts */}
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #4A90E205 0%, #4A90E215 100%)",
                      padding: "1.5rem",
                      borderRadius: "16px",
                      border: "2px solid #4A90E220",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "800",
                        color: "#4A90E2",
                        fontFamily:
                          'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
                        marginBottom: "0.5rem",
                      }}
                    >
                      ₹{apiData?.api1?.budgetLeft ?? 0}
                    </div>
                    <div
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "600",
                        color: "#374151",
                        marginBottom: "0.5rem",
                      }}
                    >
                      Budget Left
                    </div>
                    {/* <div
                      style={{
                        background: "#4A90E2",
                        color: "white",
                        padding: "0.25rem 0.75rem",
                        borderRadius: "12px",
                        fontSize: "0.75rem",
                        fontWeight: "700",
                        display: "inline-block",
                      }}
                    >
                      7%
                    </div> */}
                  </div>

                  {/* Bills & Amount Left Combined */}
                  {/* <div
                    style={{
                      background:
                        "linear-gradient(135deg, #4ECDC405 0%, #E5E5E515 100%)",
                      padding: "1rem",
                      borderRadius: "16px",
                      border: "2px solid #4ECDC420",
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.75rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: "1rem",
                            fontWeight: "700",
                            color: "#4ECDC4",
                            fontFamily:
                              'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
                          }}
                        >
                          ₹503
                        </div>
                        <div
                          style={{
                            fontSize: "0.75rem",
                            fontWeight: "600",
                            color: "#374151",
                          }}
                        >
                          Bills
                        </div>
                      </div>
                      <div
                        style={{
                          background: "#4ECDC4",
                          color: "white",
                          padding: "0.2rem 0.5rem",
                          borderRadius: "8px",
                          fontSize: "0.65rem",
                          fontWeight: "700",
                        }}
                      >
                        1%
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: "1rem",
                            fontWeight: "700",
                            color: "#9CA3AF",
                            fontFamily:
                              'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
                          }}
                        >
                          ₹9,592
                        </div>
                        <div
                          style={{
                            fontSize: "0.75rem",
                            fontWeight: "600",
                            color: "#374151",
                          }}
                        >
                          Amount Left
                        </div>
                      </div>
                      <div
                        style={{
                          background: "#9CA3AF",
                          color: "white",
                          padding: "0.2rem 0.5rem",
                          borderRadius: "8px",
                          fontSize: "0.65rem",
                          fontWeight: "700",
                        }}
                      >
                        16%
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeaderStats;
